import React, { memo } from "react";

interface RocketIconProps {
  size?: number;
}

const RocketIcon: React.FC<RocketIconProps> = memo(({ size = 44 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 80 80"
      fill="none"
      className="rocket-icon"
    >
      <mask
        id="mask0_5096_21587"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <rect width="80" height="80" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5096_21587)">
        <path
          d="M19.9445 39.8056C21.7223 35.5093 23.8102 31.4167 26.2083 27.5278C28.6065 23.6389 31.3241 19.926 34.3612 16.3889L28.3333 15.25C26.6852 14.9537 25.0741 15.037 23.5 15.5C21.9259 15.963 20.5371 16.7963 19.3333 18L8.91667 28.4722C7.82405 29.5648 7.42592 30.8565 7.72225 32.3472C8.01853 33.838 8.85186 34.8981 10.2222 35.5277L19.9445 39.8056ZM72.5556 3.97224C66.4259 3.89818 60.5833 5.04632 55.0277 7.41665C49.4722 9.78704 44.5185 13.1297 40.1667 17.4445C37.1296 20.4815 34.4629 23.6991 32.1667 27.0972C29.8704 30.4954 27.8889 34.1204 26.2222 37.9722C25.7963 38.8982 25.6157 39.8565 25.6806 40.8472C25.7454 41.838 26.1389 42.6944 26.8611 43.4167L37.6667 54.2222C38.3889 54.9445 39.2454 55.338 40.2361 55.4027C41.2268 55.4676 42.1851 55.2592 43.1111 54.7777C46.9444 53.1296 50.5648 51.1528 53.9722 48.8472C57.3796 46.5417 60.6018 43.8704 63.6388 40.8333C67.9537 36.5185 71.3055 31.5879 73.6944 26.0417C76.0833 20.4954 77.2407 14.6574 77.1667 8.52774C77.1296 7.95368 76.9953 7.38888 76.7638 6.83332C76.5324 6.27777 76.2037 5.78704 75.7777 5.36115C75.3519 4.93521 74.8611 4.60649 74.3056 4.37499C73.75 4.14354 73.1667 4.00929 72.5556 3.97224ZM51.0556 29.9444C50 28.8518 49.4722 27.537 49.4722 26C49.4722 24.463 50 23.1482 51.0556 22.0556C52.1481 21 53.4768 20.4722 55.0417 20.4722C56.6064 20.4722 57.9351 21 59.0277 22.0556C60.0833 23.1482 60.6111 24.463 60.6111 26C60.6111 27.537 60.0833 28.8518 59.0277 29.9444C57.9351 31.037 56.6064 31.5833 55.0417 31.5833C53.4768 31.5833 52.1481 31.037 51.0556 29.9444ZM41.3333 61.0555L45.5277 70.8611C46.1204 72.3241 47.1806 73.1852 48.7083 73.4444C50.2361 73.7037 51.5555 73.2592 52.6667 72.1111L63.0833 61.6944C64.287 60.5277 65.1203 59.1574 65.5833 57.5833C66.0463 56.0093 66.1296 54.3982 65.8333 52.75L64.6944 46.7221C61.1944 49.7221 57.4907 52.4166 53.5833 54.8055C49.6759 57.1944 45.5926 59.2777 41.3333 61.0555ZM10.5278 53.6111C12.9167 51.2222 15.7777 50.0277 19.1111 50.0277C22.4444 50.0277 25.3241 51.2222 27.75 53.6111C30.1389 56.037 31.3333 58.9167 31.3333 62.25C31.3333 65.5833 30.1389 68.4444 27.75 70.8333C24.6018 73.9814 20.8379 75.8703 16.4583 76.5C12.0787 77.1296 7.68522 77.6574 3.27783 78.0833C3.70372 73.6759 4.2315 69.2823 4.86117 64.9027C5.49078 60.5231 7.37966 56.7592 10.5278 53.6111Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
});

export { RocketIcon };
